import { Box, Typography } from "@mui/material"
import WidgetCard from "lib/widget-card"
import { ResolutionStatusChip } from "routes/schedule/plugins/legislation-resolutions/resolution-status-chip"

export function ProjectBridgeImportSummaryCard({ item }) {
    return (
        <WidgetCard bannerColor={`${item?.color || "primary"}.main`} sx={{ flex: 1, minWidth: 260, minHeight: 140 }}>
            <Box sx={{ color: "text.primary", width: 1 }}>
                <Typography className="title" variant="body2">
                    {item?.title}
                </Typography>
                {renderCardValue()}
            </Box>
        </WidgetCard>
    )

    function renderCardValue() {
        if (item?.status) {
            return <ResolutionStatusChip status={item.status} sx={{ mt: 1 }} />
        }

        return (
            <Typography
                variant="h4"
                className="number"
                data-cy="project-bridge-import-summary-card-total"
                sx={{ overflowWrap: "anywhere" }}
            >
                {item?.total}
            </Typography>
        )
    }
}
